import React, { useEffect, useRef, useState } from 'react'
import FormCreator from '../../../components/forms/FormCreator'
import { AddPaymentProofData } from '../data/AddPaymentProof.Data'
import { useAddOutstandingInvoicePaymentProofMutation } from '../../../app/services/PaymentReconciliation/PaymentReconciliationApi'
import { useStoreBase64ImageMutation, useUploadPDFMutation } from '../../../app/services/common/commonServiceApi'
import { FolderName } from '../../../utils/Constants'
import Buttons from '../../../components/ui/button/Buttons'
import SwalAlert from '../../../services/swalService/SwalService'
import ToastService from '../../../services/toastService/ToastService'
import { getAuditContext } from '../../../lib/authenticationLibrary'

const AddPaymentProofModel = ({ selectedInvoice, openModelAddProof }) => {
    const addPaymentProofFormRef = useRef()
    const { error, success } = SwalAlert()
    const audit = getAuditContext();
    const [file, setFile] = useState({
        PaymentProofFileName: "",
        PaymentProofEncryptedFileName: "",
    });
    const [uploadFile] = useUploadPDFMutation();
    const [imageUpload] = useStoreBase64ImageMutation();

    const [submitProof, {
        isLoading: submitIsLoading,
        isSuccess: submitIsSuccess,
        data: submitProoffData }] = useAddOutstandingInvoicePaymentProofMutation();

    useEffect(() => {
        if (!submitIsLoading && submitIsSuccess && submitProoffData) {
            debugger
            if (submitProoffData.keyId > 0 && !submitProoffData.hasError) {
                openModelAddProof();
                success("Proof added successful.")
            }
        }
    }, [submitIsLoading, submitIsSuccess, submitProoffData]);

    const handleFileUpload = async (folderName, fileInfo) => {
        const formData = new FormData();
        formData.append("file", fileInfo?.file);
        formData.append("storagePath", folderName);
        const response = await uploadFile(formData).unwrap();
        if (response)
            setFile({
                ...file,
                PaymentProofFileName: response.uploadedFileName,
                PaymentProofEncryptedFileName: response.fileName,
            });
    };

    const handleImageUpload = async (fileDetails, storagePath) => {
        const request = {
            fileName: fileDetails?.fileName,
            fileStr: fileDetails?.base64Data,
            storagePath: storagePath,
        };
        const response = await imageUpload(request).unwrap();
        if (response) {
            setFile({
                ...file, PaymentProofFileName: response.uploadedFileName, PaymentProofEncryptedFileName: response.fileName,
            });
            ToastService.success("Image proof uploaded successfully.")
        }
    }

    const handleFieldChange = (dataFieldName, updateFormData) => {
        if (dataFieldName === "profOfPaymentFile") {
            if (Array.isArray(updateFormData?.profOfPaymentFile) && updateFormData?.profOfPaymentFile?.length === 0) {
                setFile({ ...file, PaymentProofFileName: null, PaymentProofEncryptedFileName: null });
                return;
            }
            let parts = updateFormData?.profOfPaymentFile?.fileName.split(".");
            let extension = parts[parts.length - 1].toLowerCase();
            if (extension === "pdf")
                handleFileUpload(FolderName.FilePaymentProof, updateFormData[dataFieldName]);
            else
                handleImageUpload(updateFormData?.profOfPaymentFile, FolderName.ImagePaymentProof);
        }
    };

    const handleChange = (dataFieldName, updateFormData) => {
        if (dataFieldName === "profOfPaymentFile") {
            handleFieldChange(dataFieldName, updateFormData)
        }
    };

    const handleSave = () => {
        let formData = addPaymentProofFormRef?.current?.getFormData();
        console.log({ selectedInvoice })
        if (!formData || !file.PaymentProofEncryptedFileName || file.PaymentProofEncryptedFileName === '')
            return error("Please fill all mandatory fields.")
        const { membershipPaymentId, bookingId, ipasMemberId, membershipPaymentTypeId } = selectedInvoice;
        const request = {
            IPASMemberId: ipasMemberId,
            MembershipPaymentId: membershipPaymentId,
            BookingId: bookingId,
            Comments: formData?.comments || "",
            PaymentProofFileName: file?.PaymentProofFileName,
            PaymentProofEncryptedFileName: file?.PaymentProofEncryptedFileName,
            PaymentMethodId: formData?.paymentMethod?.value || 1, // sending default Bank transfer
            MembershipPaymentTypeId: membershipPaymentTypeId,
            CreatedBy: audit.adminUserId,
            CreatedAppId: audit.appId
        }
        submitProof(request);
    }

    return (
        <div className="col-lg-12">
            <div className="row">
                <div className="col-lg-12">
                    <h6>File 1</h6>
                </div>
                <div className="col-lg-8 col-8 mobile-100">
                    <input
                        type="text"
                        value={
                            file?.PaymentProofFileName ||
                            ""
                        }
                        disabled={true}
                        className="form-input-group"
                        style={{
                            width: "100%",
                            height: "40px",
                            border: "1px solid #ccc",
                            padding: "10px",
                        }}
                    />
                </div>

                <FormCreator
                    config={AddPaymentProofData}
                    ref={addPaymentProofFormRef}
                    key={false}
                    onColumnChange={handleChange}
                />
            </div>
            <Buttons
                onClick={handleSave}
                buttonText={"Save"}
                buttonTypeClassName="theme-btn btn mt-auto"
                isLoading={submitIsLoading}
            />
        </div>
    )
}

export default AddPaymentProofModel
